import { Injectable } from '@angular/core';
import keys from 'lodash/keys';

import { environment } from '@env/environment';
import { Endpoint, reverseEndpoint } from './_models';

@Injectable({
	providedIn: 'root'
})
export class EndpointService {
	constructor() {}

	private get portalUrl(): string {
		return environment.server;
	}

	private get sisUrl(): string {
		return environment.sis;
	}

	public url(endpoint: Endpoint | string, params: object = null): string {
		const base = endpoint.startsWith("/rest") ? this.sisUrl : this.portalUrl;
		let url = `${base}${endpoint}`;
		if (params) {
			let search = '';
			let amp = '';
			const list = keys(params);
			list.forEach((key) => {
				const value = params[key];
				search += `${amp}${key}`;
				if (value !== undefined && value !== null && value !== '') {
					search += `=${value}`;
				}
				amp = '&';
			});
			if (search !== '') {
				url += `?${search}`;
			}
		}
		return url;
	}

	public isApiCall(url: string): boolean {
		return url.indexOf(this.portalUrl) === 0 || url.indexOf(this.sisUrl + "/rest") === 0;
	}

	public getEndpoint(url: string): Endpoint {
		const trimmed = url.replace(this.portalUrl, '').replace(this.sisUrl, '');
		let ep = reverseEndpoint(trimmed);
		if (!ep) {
			ep = reverseEndpoint(trimmed.split('?')[0]);
		}

		return ep;
	}

	public isBrsInit(url: string): boolean {
		return url.indexOf(Endpoint.brsJwtToken) >= 0;
	}

	public isBrsCall(url: string): boolean {
		return url.indexOf(environment.registrations) >= 0;
	}
}
